import assign from '../_helpers/assign.js';
import _afterInit from './_afterinit.js';
import mediateItem from './mediateitem.js';
import orderBy from './orderby/index.js';
import pull from './pull.js';
import recreate from './recreate/index.js';
import rerender from './rerender.js';
import restore from './restore.js';
import toJSON from './tojson.js';
import pseudoNativeMethods from './_pseudonativemethods/index.js';
import iterator from './iterator.js';
import addSymbolMembers from '../_helpers/addsymbolmembers.js';
// the instance members Class builds Matreshka.Array from; index.ts adds extends and constructor
var instanceMembers = assign({
  _afterInit: _afterInit,
  mediateItem: mediateItem,
  orderBy: orderBy,
  pull: pull,
  recreate: recreate,
  rerender: rerender,
  restore: restore,
  toJSON: toJSON,
  length: 0,
  isMatreshkaArray: true
}, pseudoNativeMethods);
addSymbolMembers(instanceMembers, iterator, true);
export default instanceMembers;